import { useState } from 'react';
import { User } from '../types/cabinet.types';
import { updateProfile, sendVerificationEmail } from '../api/cabinetApi';
import { useAuth } from './useAuth';

export const useUserProfile = () => {
  const { user, refreshUser } = useAuth();
  const [isUpdating, setIsUpdating] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const update = async (data: Partial<User>) => {
    setIsUpdating(true);
    setError(null);
    try {
      await updateProfile(data);
      await refreshUser(); // Fetch latest profile after update
      return true;
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Failed to update profile'));
      return false;
    } finally {
      setIsUpdating(false);
    }
  };

  const verifyEmail = async () => {
    try {
      await sendVerificationEmail();
      return true;
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Failed to send verification email'));
      return false;
    }
  };

  return {
    user,
    isUpdating,
    error,
    update,
    verifyEmail,
  };
};
